export default __webpack_public_path__ + "static/media/pot.d78d533b.png";